// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._7pG-va6jh2-yzYhFrpMaqQ\\=\\={color:#9c63ff;font-weight:600}", "",{"version":3,"sources":["webpack://./Resources/assets/js/react/components/_ui/title/style.module.scss"],"names":[],"mappings":"AAAA,6BAEE,aAAA,CADA,eAEF","sourcesContent":[".title {\r\n  font-weight: 600;\r\n  color: #9c63ff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "_7pG-va6jh2-yzYhFrpMaqQ=="
};
export default ___CSS_LOADER_EXPORT___;
